import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';
import moment from 'moment';
import DataItemCheckbox from '../../../../../_common/components/DataItemCheckbox';
import DataItem from '../../../../../_common/components/DataItem';
import {limitValueMaxFloat} from '../../../../../../../utils';

export default function InvoicesList({
                                       invoicesGridData,
                                       disabledFields,
                                       multipleAgents,
                                       allValues,
                                       setDisabledFields,
                                       popupRowIndex,
                                       setFieldValue
                                     }) {
  const getInvoicesArray = allValues => {
    if (multipleAgents) {
      return (allValues.lines.length > 0)
        ? allValues.lines.map(item => item.invoices)
        : [];
    } else {
      return allValues.invoices;
    }
  };
  const invoicesArray = getInvoicesArray(allValues);

  useEffect(() => {
    disableCheckboxes();
    resetAllCheckboxes();
    checkSelectedCheckboxes();
  }, [allValues.lines]);

  const disableCheckboxes = () => {
    const disabled = findDisabled(invoicesArray);
    setDisabledFields(disabled);
  };

  const resetAllCheckboxes = () => {
    const ids = findAllIds(invoicesGridData);
    ids.forEach(fieldName => setFieldValue(fieldName, false));
  };

  const checkSelectedCheckboxes = () => {
    const checked = findChecked(invoicesArray);
    checked.forEach(fieldName => setFieldValue(fieldName, true));
  };

  const findDisabled = invoicesArray => {
    const arr = invoicesArray.length > 0 && invoicesArray.filter((item, index) => {
      if (index !== popupRowIndex) {
        return item;
      }
    });
    const flattedArray = arr && arr.flat();
    return Boolean(flattedArray) ? flattedArray.map(item => item.invoiceID) : [];
  };

  const findAllIds = invoicesGridData => {
    return invoicesGridData.map(item => item._id);
  };

  const findChecked = invoicesArray => {
    return invoicesArray.flat().map(item => item.invoiceID);
  };

  const mapRows = (row) => {
    const {
      _id: id,
      agentId,
      datetime,
      amount,
      isActual
    } = row;

    const disabledCondition = (multipleAgents && disabledFields.includes(id)) || !isActual;

    return (
      <div
        key={id}
        className={`d-flex justify-content-between`}
      >
        <div className="cell">
          <DataItemCheckbox
            containerClassname={`d-flex align-items-center ${disabledCondition ? 'opacity-30' : ''}`}
            fieldName={`${id}`}
            disabled={disabledCondition}
          />
        </div>
        <div className="font-weight-bolder font-size-sm cell">
          {id}
        </div>
        <div className="font-weight-bolder font-size-sm cell">
          {agentId}
        </div>
        <div className="font-weight-bolder font-size-sm cell">
          {moment(datetime).format('DD-MM-YYYY')}
        </div>
        <div dir={'ltr'} className="font-weight-bolder font-size-sm cell">
          <DataItem
            dir={'ltr'}
            customInputStyle="text-center custom-data-item"
            fieldId={`amount-${id}`}
            customValue={amount ? parseFloat(amount).toFixed(2) : ''}
            disabled={true}
          />
        </div>
        <div className="cell">
          <DataItem
            dir={'ltr'}
            customInputStyle="text-center custom-data-item"
            fieldId={`closeAmount-${id}`}
            onChange={limitValueMaxFloat(amount)}
          />
        </div>
      </div>
    );
  };

  const intl = useIntl();
  const cellNumber = intl.formatMessage({
    id: 'receipts-popup-invoices-list-number',
    defaultMessage: 'Number',
  });
  const cellAgentID = intl.formatMessage({
    id: 'receipts-popup-invoices-list-agentID',
    defaultMessage: 'AgentID',
  });
  const cellDate = intl.formatMessage({
    id: 'receipts-popup-invoices-list-date',
    defaultMessage: 'Date',
  });
  const cellAmount = intl.formatMessage({
    id: 'receipts-popup-invoices-list-total-amount',
    defaultMessage: 'Amount',
  });
  const cellNewAmount = intl.formatMessage({
    id: 'receipts-popup-invoices-list-newAmount',
    defaultMessage: 'New amount',
  });

  const arrayCellsHeaders = [
    null,
    cellNumber,
    cellAgentID,
    cellDate,
    cellAmount,
    cellNewAmount,
  ];

  const mapHeaders = item => {
    return (
      <div className="header-cell">
        {item}
      </div>
    );
  };

  return (
    <div className="popup-invoices-list">
      <div className="d-flex justify-content-between custom-brand-color header">
        {arrayCellsHeaders.map(mapHeaders)}
      </div>
      <div>
        {invoicesGridData.map(mapRows)}
      </div>
    </div>
  );
}
